import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OrganizationPortalBlockData from '../../../Models/Content/OrganizationPortalBlockData';
import OrganizationPortalMain from './OrganizationPortalMain';

export default class UploadOrgUsersListBlock extends EpiComponent<OrganizationPortalBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (
          <OrganizationPortalMain iContent={this.props.data}/>
      )
    }
}
